module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"viewPolicy.title":"View Policy"}}')
  delete Component.options._Ctor
}
